// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"583":"83cfb3de","759":"31d6cfe0","828":"ad56ec75"}[chunkId] + ".chunk.css";
};